import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/heroSlides';

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  const go = (index: number) => {
    setActive((index + heroSlides.length) % heroSlides.length);
  };

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="relative h-[440px] w-full sm:h-[500px] md:h-[560px]">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? 'opacity-100' : 'pointer-events-none opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              title={`${slide.title} - 蜜桃网影视资讯推荐`}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/50 to-foreground-950/20" />
            <div className="absolute inset-0 flex items-center">
              <div className="mx-auto w-full px-4 md:px-8">
                <div className="max-w-2xl">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-semibold text-background-50">
                    <i className="ri-fire-fill text-[13px]" />
                    {slide.tag}
                  </span>
                  <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
                    {slide.title}
                  </h2>
                  <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
                    {slide.subtitle}
                  </p>
                  <Link
                    to={slide.link}
                    className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-500"
                  >
                    {slide.cta}
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        <button
          type="button"
          onClick={() => go(active - 1)}
          aria-label="上一张"
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm transition-colors hover:bg-primary-500 md:flex"
        >
          <i className="ri-arrow-left-s-line text-2xl" />
        </button>
        <button
          type="button"
          onClick={() => go(active + 1)}
          aria-label="下一张"
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm transition-colors hover:bg-primary-500 md:flex"
        >
          <i className="ri-arrow-right-s-line text-2xl" />
        </button>

        <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {heroSlides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              onClick={() => go(index)}
              aria-label={`切换到 ${slide.title}`}
              className={`h-2 rounded-full transition-all ${
                index === active ? 'w-6 bg-primary-500' : 'w-2 bg-background-50/60 hover:bg-background-50'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}